export const Image1 = require("./image1.png");
export const Image2 = require("./image2.png");
export const Image3 = require("./image3.png");
export const Image4 = require("./image4.png");
export const Image5 = require("./image5.png");
export const Image6 = require("./image6.png");
export const Image7 = require("./image7.png");
export const Image8 = require("./image8.png");
export const Image9 = require("./Echoes-1.png")